'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('../../../node_modules/react/jsx-runtime.js');
var index = require('../../../node_modules/@hcaptcha/react-hcaptcha/dist/esm/index.js');

const HCaptcha = (props) => {
    return jsxRuntime.jsxRuntimeExports.jsx("div", { "data-testid": "hcaptcha", children: jsxRuntime.jsxRuntimeExports.jsx(index.default, { sitekey: props.siteKey, languageOverride: props.language, onVerify: props.onVerified }) });
};

exports.default = HCaptcha;
//# sourceMappingURL=HCaptcha.js.map
